import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import StatsBanner from './components/StatsBanner';
import LatestUpdate from './components/LatestUpdate';
import { siteInfo } from '@/mocks/comics';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: siteInfo.name,
            url: siteInfo.url,
            description: siteInfo.description,
            email: siteInfo.email,
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressCountry: 'CN',
            },
          }),
        }}
      />
      <main>
        <HeroSection />
        <StatsBanner />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />
      </main>
    </>
  );
}